import React from 'react';

import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M10.5 2.49667V1.16667C10.5 0.525 9.975 0 9.33333 0H1.16667C0.519167 0 0 0.525 0',
  '1.16667V9.33333C0 9.975 0.519167 10.5 1.16667 10.5H9.33333C9.975 10.5 10.5 9.975 10.5',
  '9.33333V8.00333C10.8442 7.79917 11.0833 7.43167 11.0833 7V3.5C11.0833 3.06833 10.8442',
  '2.70083 10.5 2.49667ZM9.91667 3.5V7H5.83333V3.5H9.91667ZM1.16667 9.33333V1.16667H9.33333V2.33333H5.83333C5.19167',
  '2.33333 4.66667 2.85833 4.66667 3.5V7C4.66667 7.64167 5.19167 8.16667 5.83333',
  '8.16667H9.33333V9.33333H1.16667ZM7.58333 6.125C8.06658 6.125 8.45833 5.73325 8.45833',
  '5.25C8.45833 4.76675 8.06658 4.375 7.58333 4.375C7.10008 4.375 6.70833 4.76675 6.70833',
  '5.25C6.70833 5.73325 7.10008 6.125 7.58333 6.125Z',
].join(' ');

export const IconPayoutReserve = ({ width = 12, height = 11, color = '#0E5BF3', className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path d={path} fill={color} />
  </Svg>
);
